import { MASTERMULTITOTAL } from "../../../constants/cinemaTypes"

const chooseCinemasActive = (multicinemaMode) => multicinemaMode === MASTERMULTITOTAL

export default chooseCinemasActive